import { useState, type Dispatch, type SetStateAction } from 'react';

/**
 * Tekstveld met een lokale waarde die pas bij `blur` naar Dexie gaat: één
 * mutatie per bewerking in plaats van één per toetsaanslag. Verandert de
 * opgeslagen waarde buiten het veld om (een overgenomen suggestie, een
 * binnengekomen sync), dan volgt het veld mee.
 *
 * Dit is het "state aanpassen tijdens render"-patroon uit de React-docs, niet
 * een effect: een effect zou een extra render kosten bij elke toetsaanslag.
 */
export function useDraftText(external: string): [string, Dispatch<SetStateAction<string>>] {
    const [text, setText] = useState(external);
    const [previous, setPrevious] = useState(external);

    if (external !== previous) {
        setPrevious(external);
        setText(external);
    }

    return [text, setText];
}
